// extracted by mini-css-extract-plugin
export default {"flex":"VoucherNumber_flex__TlKLg","title":"VoucherNumber_title__4YVdm","input_text":"VoucherNumber_input_text__6Q5Kp"};